module.exports = __webpack_public_path__ + "static/media/sunday_times_cropped.79179ace.png";